import { createTheme, Theme, ThemeNames } from '@bechtel/gds';
interface ComponentStyles {
  navBarWidth: string;
  boxShadow: string;
  boxShadowInverted: string;
  pageHeaderHeight: string;
}
const defaultTheme = createTheme(ThemeNames.GLOBAL_THEME);

const componentStyles: ComponentStyles = {
  navBarWidth: '80px',
  boxShadow: '0 2px 4px 0 rgb(0 0 0 / 20%)',
  boxShadowInverted: '0 -2px 4px 0 rgba(0, 0, 0, 0.2)',
  pageHeaderHeight: '50px',
};

const themeTokens = {
  light: {
    primary: defaultTheme.colors.primary,
    secondary: defaultTheme.colors.grey[600],
  },
  dark: {},
};

const appThemes = {
  componentStyles,
};

export const appTheme = (): Theme => {
  const appColors = themeTokens['light'];
  return {
    ...defaultTheme,
    colors: { ...defaultTheme.colors, primary: appColors.primary },
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //@ts-ignore
    fontFamilies: {
      ...defaultTheme.fontFamilies,
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      //@ts-ignore
      openSansBold: 'Open Sans Bold, sans-serif',
      openSansSemiBold: 'Open Sans Semi Bold, sans-serif',
      fixedWidth: 'Ludica, Courier',
      cursiveFont: 'Cursive HandWriting',
    }, //TODO: Move open sans bold to gds
    ...appThemes,
  };
};
